import React, { useState } from 'react';
import './../index.css';
import ImageList from '@mui/material/ImageList';
import PhotoModal from './PhotoModal';
import useFirestore from './../hooks/useFirestore';
import ImageListItem from '@mui/material/ImageListItem';

export default function ImageGrid() {
  const { documents } = useFirestore('images');
  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [clickedPhoto, setClickedPhoto] = useState(null);

  const handlePhotoModalOpen = () => {
    setPhotoModalOpen(!photoModalOpen);
  }

  const handlePhotoClick = (event) => {
    setClickedPhoto(event.target.src);
    setPhotoModalOpen(true);
  }

  return (
    <div>
      <div className="image-list-div">
        <ImageList sx={{ width: '50%', height: '100%' }} cols={3}>
          {documents && documents.map((doc) => (
            <ImageListItem sx={{ height: '75%', width: '95%', margin: '2px', objectFit: 'cover' }} key={doc.id}>
              <img
                className="img-item"
                src={doc.url}
                srcSet={`${doc.url} 1x`}
                alt={doc.id}
                loading="lazy"
                onClick={handlePhotoClick}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </div>
      <PhotoModal photoURL={clickedPhoto} photoModalOpen={photoModalOpen} handlePhotoModalOpen={handlePhotoModalOpen} />
    </div>)
}